import React, { memo } from "react";
import FilterTable from "./FilterTable";
import { TableSearch } from "./TableSearch";
import useTableCtx from "../tableContext/useTableCtx";
import TableDatePicker from "./TableDatePicker";
import TableOrder from "./TableOrder";

const TableHeaderCategories = memo(
  ({
    showActionButtons = true,
    showSearchForCategories = true,
    withFiller = false,
  }: {
    showActionButtons?: boolean;
    showSearchForCategories?: boolean;
    withFiller?: boolean;
  }) => {
    const { tableHeader: tableHeaderCategories, tableOrder } = useTableCtx()!;

    const withSearchOrFilter = tableHeaderCategories.some(
      ({ withSearch, withFilter, withDatePicker }) =>
        withSearch || withFilter || withDatePicker,
    );

    return (
      <thead>
        {showSearchForCategories && withSearchOrFilter && (
          <tr className="bg-surface-subtle text-base text-muted [&_th]:py-3 [&_th]:font-semibold">
            {tableHeaderCategories.map(
              (
                {
                  value,
                  label,
                  minW,
                  maxW,
                  withSearch,
                  withFilter,
                  withDatePicker,
                  filterDefaultIdx,
                },
                idx,
                categories,
              ) => (
                <th
                  key={value}
                  style={{
                    minWidth: minW,
                    maxWidth: maxW,
                  }}
                  className={`text-left ${
                    idx === 0
                      ? "pl-3 rounded-l-control"
                      : idx === categories.length - 1
                      ? "pr-3 rounded-r-control"
                      : ""
                  }`}>
                  {withSearch && (
                    <TableSearch
                      value={value}
                      label={label}
                      withSearch={withSearch}
                    />
                  )}
                  {withFilter && withFilter.length && (
                    <FilterTable
                      value={value}
                      label={label}
                      withFilter={withFilter}
                      filterDefaultIdx={filterDefaultIdx}
                    />
                  )}
                  {withDatePicker && (
                    <TableDatePicker
                      value={value}
                      withDatePicker={withDatePicker}
                    />
                  )}
                </th>
              ),
            )}
            {showActionButtons && (
              <th className="rounded-r-control text-right"></th>
            )}
            {withFiller && <th aria-hidden="true" />}
          </tr>
        )}
        <tr aria-hidden="true" style={{ height: 10 }} />
        <tr className="bg-surface-subtle text-base text-muted [&_th]:py-3 [&_th]:font-semibold">
          {tableHeaderCategories.map(
            ({ label, value, minW, maxW, withOrder }, idx, categories) => (
              <th
                key={value}
                scope="col"
                aria-sort={
                  withOrder && tableOrder?.[value]
                    ? tableOrder[value] === "asc"
                      ? "ascending"
                      : "descending"
                    : undefined
                }
                style={{
                  minWidth: minW,
                  maxWidth: maxW,
                  overflowWrap: "anywhere",
                }}
                className={`text-left ${
                  idx === 0
                    ? "pl-3 rounded-l-control"
                    : idx === categories.length - 1
                    ? "pr-3 rounded-r-control"
                    : ""
                }`}>
                <TableOrder label={label} value={value} withOrder={withOrder} />
              </th>
            ),
          )}
          {showActionButtons && (
            <th scope="col" className="rounded-r-control text-right">
              Actiuni
            </th>
          )}
          {withFiller && <th aria-hidden="true" />}
        </tr>
      </thead>
    );
  },
);

export default TableHeaderCategories;
